export default __webpack_public_path__ + "static/q_smarttrike-290db75b3d3e4f245104fb11a6244475.png";